import script from "./CommonTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommonTabs.vue?vue&type=script&setup=true&lang=ts"

import "./CommonTabs.vue?vue&type=style&index=0&id=bbb8826e&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbb8826e"]])

export default __exports__